import fornecedor from './fornecedor'
import material from './material'
import unidade from './unidade'
import fabricante from './fabricante'
import periodoContabil from './periodoContabil'
import aprovacaoEntrada from './aprovacaoEntrada'

export default [
    ...fornecedor,
    ...material,
    ...unidade,
    ...fabricante,
    ...periodoContabil,
    ...aprovacaoEntrada,
]